import { Box, Card, CardContent, CardMedia, CardMediaProps, styled } from '@mui/material';
import { device } from 'src/constants/mediaQueries';

export const Form = styled('div')`
  display: flex;
  gap: 5rem;
  margin: 1rem;
  @media ${device.belowLargeDesktop} {
    flex-direction: column;
    width: 450px;
  }
`;

export const SectionTitle = styled('h2')`
  font-size: ${({ theme }) => theme.typography.h5.fontSize};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  @media only screen and ${device.mobileOrTablet} {
    font-size: ${({ theme }) => theme.typography.h6.fontSize};
  }
  margin-bottom: 0;
`;

const containerWidth = {
  desktop: 400,
  mobile: 350,
};
export const ThumbnailContainer = styled(Card)<CardMediaProps>`
  margin: 1rem;
  width: ${containerWidth.desktop}px;
  height: 390px;
  overflow: hidden;
  @media ${device.smallMobile} {
    width: ${containerWidth.mobile}px;
  }
`;

export const Thumbnail = styled(CardMedia)<CardMediaProps>`
  width: ${containerWidth.desktop}px;
  object-fit: contain;
  aspect-ratio: 4/3;
  overflow: hidden;
  @media ${device.smallMobile} {
    width: ${containerWidth.mobile}px;
  }
`;

export const ThumbnailAction = styled(CardContent)`
  display: flex;
  flex-direction: row;
  padding: 1rem;
  background: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-size: 1rem;
  height: 100px;
  min-width: 0;
`;

export const ThumbnailActionInfo = styled('div')`
  padding-left: 1rem;
  display: flex;
  flex-direction: column;
`;

export const Fields = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 550px;
  padding: 1rem 0;
  @media ${device.belowLargeDesktop} {
    padding: 0;
  }
`;

export const LoadingSpinnerContainer = styled(Box)`
  display: table;
  margin-inline: auto;
`;

export const ThumbnailTitleContainer = styled(Box)`
  margin-bottom: 0.5rem;
`;
